import React from "react";
import { useHistory } from "react-router-dom";

import { Page } from "ui/components";

const TermsScreen = () => {
  const History = useHistory();
  return (
    <Page title={`Kebijakan Privasi`} backTo={() => History.goBack()}>
      <div className="p-2">
        <p
          className="fs-7 mb-1 "
          style={{ textIndent: 10, textAlign: "justify" }}
        >
          Kebijakan privasi berikut ini akan menjelaskan bagaimana PT Envio
          Global Persada selaku penyedia layanan logistik digital mengumpulkan,
          menggunakan, memindahkan, mengungkapkan dan melindungi informasi
          pribadi anda yang dapat diidentifikasi yang diperoleh melalui Aplikasi
          kami (sebagaimana didefinisikan di bawah). Mohon anda membaca
          Kebijakan Privasi ini dengan seksama untuk memastikan bahwa anda
          memahami bagaimana ketentuan Kebijakan Privasi ini kami berlakukan.
          Kebijakan Privasi ini disertakan sebagai bagian dari Ketentuan
          Penggunaan kami. Kebijakan Privasi ini mencakup hal-hal sebagai
          berikut:
        </p>

        <div>
          <ol type="A" className="ps-3">
            <li>Informasi yang dikumpulkan</li>
            <p
              className="fs-7 mb-1 "
              style={{ textIndent: 10, textAlign: "justify" }}
            >
              Envio mengumpulkan informasi anda dengan tujuan hanya untuk
              memproses dan mempermudah transaksi yang terjadi di aplikasi.
            </p>
            <ol className="ps-3">
              <li>Informasi yang diberikan secara langsung.</li>
              <p
                className="fs-7 mb-1 "
                style={{ textIndent: 10, textAlign: "justify" }}
              >
                Kami mengumpulkan Informasi Pribadi tertentu dari anda agar
                aplikasi dapat menemukan layanan dari Penyedia Layanan. Anda
                akan langsung memberikan Informasi Pribadi (sebagai contoh, saat
                anda mendaftar) dan beberapa informasi akan secara otomatis
                dikumpulkan ketika anda menggunakan Aplikasi. Informasi ini
                umumnya termasuk tetapi tidak terbatas pada alamat, nomor
                telepon, email, lokasi fisik, gambar, dan informasi lainnya yang
                mungkin berguna dalam proses penyediaan layanan kami.
              </p>
              <li>
                Informasi yang dikumpulkan saat anda menggunakan aplikasi.
              </li>
              <p
                className="fs-7 mb-1 "
                style={{ textIndent: 10, textAlign: "justify" }}
              >
                Kami mengumpulkan informasi berupa waktu dari setiap aktivitas
                pengguna, termasuk aktivitas pendaftaran, login, transaksi, dan
                lain sebagainya.
              </p>
            </ol>
            <li>Penggunaan Informasi</li>
            <p
              className="fs-7 mb-1 "
              style={{ textIndent: 10, textAlign: "justify" }}
            >
              Envio menggunakan sebagian atau keseluruhan data yang dikumpulkan
              untuk memproses segala permintaan layanan yang disediakan dan
              untuk kepentingan pelatihan, untuk kepentingan kepatuhan, dan
              untuk memperbaiki kualitas layanan kami.
            </p>
            <p
              className="fs-7 mb-1 "
              style={{ textIndent: 10, textAlign: "justify" }}
            >
              Data pribadi dikumpulkan sehingga kami dapat memberikan Layanan
              sebaik mungkin dan juga untuk menyesuaikan dan meningkatkan
              pengalaman anda dalam menggunakan Layanan kami. Untuk melakukan
              hal-hal tersebut, data pribadi yang diberikan pengguna kepada
              kami, akan diberikan kepada Pengemudi untuk tujuan pelaksanaan dan
              penyelesaian Pengiriman, yang berarti bahwa data pribadi dari
              pengguna yang membuat permintaan pengiriman akan diberikan kepada
              pengguna lainnya yang menyediakan transportasi untuk pengiriman
              dan sebaliknya.
            </p>
            <p
              className="fs-7 mb-1 "
              style={{ textIndent: 10, textAlign: "justify" }}
            >
              Kami juga menggunakan informasi yang dikumpulkan untuk: analisis
              statistik; mengembangkan dan memperbaiki Perangkat Lunak dan
              Layanan; untuk memperbaharui catatan anda; untuk mengidentifikasi
              produk kami yang mungkin menarik bagi anda; dan untuk riset pasar.
            </p>
            <p
              className="fs-7 mb-1 "
              style={{ textIndent: 10, textAlign: "justify" }}
            >
              Kami tidak menjual, memberikan, mendistribusikan, atau menyebarkan
              data pribadi kepada pihak ketiga, kecuali dalam situasi berikut:
            </p>
            <p
              className="fs-7 mb-1 "
              style={{ textIndent: 10, textAlign: "justify" }}
            >
              Untuk meningkatkan dan mendukung proses operasional sistem dan
              layanan, kami mungkin membagikan data kepada mitra terpercaya kami
              yang telah terikat dengan kerahasiaan sebagaimana terdapat dalam
              Kebijakan Privasi ini dan akan menjaga kerahasiaan data pribadi
              anda; Kami juga dapat mengungkapkan memberikan akses atau
              membagikan Informasi Pribadi anda dengan afiliasi dan pihak lain
              untuk tujuan yang diizinkan oleh peraturan perundang-undangan yang
              berlaku untuk meningkatkan pengalaman pengguna pada sistem kami
              dan untuk memberikan promosi kepada pengguna, kami menjalin
              kerjasama dengan mitra terpercaya kami yang telah sepakat untuk
              menjaga kerahasiaan data pribadi.
            </p>
            <li>Penggunaan Informasi</li>
            <p
              className="fs-7 mb-1 "
              style={{ textIndent: 10, textAlign: "justify" }}
            >
              Kerahasiaan Informasi Pribadi anda adalah hal yang terpenting bagi
              kami. Kami akan memberlakukan upaya terbaik untuk melindungi dan
              mengamankan data dan Informasi Pribadi anda dari akses,
              pengumpulan, penggunaan atau pengungkapan oleh orang-orang yang
              tidak berwenang dan dari pengolahan yang bertentangan dengan
              hukum, kehilangan yang tidak disengaja, pemusnahan dan kerusakan
              atau risiko serupa. Namun, pengiriman informasi melalui internet
              tidak sepenuhnya aman. Walau kami akan berusaha sebaik mungkin
              untuk melindungi Informasi Pribadi anda, anda mengakui bahwa kami
              tidak dapat menjamin keutuhan dan keakuratan Informasi Pribadi apa
              pun yang anda kirimkan melalui Internet, atau menjamin bahwa
              Informasi Pribadi tersebut tidak akan dicegat, diakses,
              diungkapkan, diubah atau dihancurkan oleh pihak ketiga yang tidak
              berwenang, karena faktor-faktor di luar kendali kami. Anda
              bertanggung jawab untuk menjaga kerahasiaan detail Akun anda,
              termasuk kata sandi anda dan One Time Password (OTP) dengan
              siapapun dan harus selalu menjaga dan bertanggung jawab atas
              keamanan perangkat yang anda gunakan.
            </p>
            <li>Pengakuan dan Persetujuan</li>
            <p
              className="fs-7 mb-1 "
              style={{ textIndent: 10, textAlign: "justify" }}
            >
              Dengan menggunakan Aplikasi, anda mengakui bahwa anda telah
              membaca dan memahami Kebijakan Privasi ini dan Ketentuan
              Penggunaan dan setuju dan sepakat terhadap penggunaan, praktek,
              pemrosesan dan pengalihan informasi pribadi anda oleh kami
              sebagaimana dinyatakan di dalam Kebijakan Privasi ini.
            </p>
            <li>Perubahan atas Kebijakan Privasi</li>
            <p
              className="fs-7 mb-1 "
              style={{ textIndent: 10, textAlign: "justify" }}
            >
              Kami dapat memperbaharui Kebijakan Privasi sewaktu-waktu jika kami
              anggap sesuai dengan hukum yang berlaku. Setiap perubahan
              Kebijakan Privasi berlaku sesegera mungkin dan dapat dilihat di
              Situs Web atau Perangkat Lunak.
            </p>
          </ol>
        </div>
      </div>
    </Page>
  );
};

export default TermsScreen;
